<template>
  <div
    v-click-outside="closeDropdown"
    class="dropdown dropdown--user inline-flex"
  >
    <!-- Logged user / login -->
    <div
      v-if="oidc.isLoggedIn"
      @click.prevent="toggleDropdown"
      :class="isDropdownOpen ? 'avatar--active' : ''"
      class="avatar avatar--signed-in cursor-pointer"
    >
      <img
        v-if="oidcUserPicture"
        :src="oidcUserPicture"
        :alt="oidcUserName"
        :title="oidcUserName"
      />
      <span v-else>
        {{ getInitials(oidcUserName) }}
      </span>
    </div>
    <a
      v-else
      @click.prevent="login"
    >
      <DefaultIconsAccount
        :class="isDropdownOpen ? 'dropdown__icon--active' : ''"
        class="dropdown__icon"
      />
    </a>
    <Transition name="dropdown-animation">
      <div
        v-show="isDropdownOpen"
        class="dropdown__container"
      >
        <div class="dropdown__content">
          <div
            v-if="oidc.isLoggedIn"
            class="flex items-center w-full px-4 pt-2"
          >
            <div class="avatar avatar--signed-in">
              <img
                v-if="oidcUserPicture"
                :src="oidcUserPicture"
                :alt="oidcUserName"
                :title="oidcUserName"
              />
              <span v-else>
                {{ getInitials(oidcUserName) }}
              </span>
            </div>
            <div class="text-sm font-bold whitespace-nowrap">
              {{ oidcUserName }}
            </div>
          </div>
          <NuxtLink
            v-if="oidc.isLoggedIn"
            :to="getProfilePath()"
            class="btn btn--sm"
          >
            {{ $t('profile.go_to_profile_page') }}
            <DefaultIconsArrowRight/>
          </NuxtLink>
          <NuxtLink
            v-else
            @click="login"
            class="btn btn--sm my-2"
          >
            {{ $t('profile.login') }}
          </NuxtLink>
          <!--            TO DO pridat link na registraci-->
          <!--          <NuxtLink class="btn btn&#45;&#45;sm my-2">-->
          <!--            {{ $t('profile.register') }}-->
          <!--          </NuxtLink>-->
          <!--            TO DO pridat link na registraci-->
          <hr v-if="oidc.isLoggedIn">
          <NuxtLink
            v-if="oidc.isLoggedIn"
            @click.prevent="logout"
            class="btn btn--sm"
          >
            {{ $t('profile.logout') }}
            <DefaultIconsSignOut/>
          </NuxtLink>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";

const config = useRuntimeConfig()
const localePath = useLocalePath()
const oidc = useProfile()
const oidcUserPicture = oidc.user?.picture
const oidcUserName = oidc.user?.name
const isLoginLoading = ref(false)
const isDropdownOpen = ref(false)

const getProfilePath = () => {
  return localePath({name: 'profile'})
}

const getInitials = (fullName: string) => {
  if (!fullName) {
    return 'CN'
  }
  const allNames = fullName.trim().split(' ');
  const initials = allNames.reduce((acc, curr, index) => {
    if (index === 0 || index === allNames.length - 1) {
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, '');
  return initials;
}

const login = () => {
  if (isLoginLoading.value) {
    return
  }
  isLoginLoading.value = true
  console.log('oidc', oidc, oidc.login)
  oidc.login()
}

const logout = () => {
  if (isLoginLoading.value) {
    return
  }
  isLoginLoading.value = true
  oidc.logout()
}

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
}

const closeDropdown = () => {
  isDropdownOpen.value = false;
}

// click-outside directive
const vClickOutside = {
  mounted(el, binding) {
    el._clickOutside = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el._clickOutside);
  },
  unmounted(el) {
    document.removeEventListener('click', el._clickOutside);
  },
};
</script>

<style scoped>
/* Animation styles for dropdown reveal */
.dropdown-animation-enter-active,
.dropdown-animation-leave-active {
  transition: opacity 240ms ease-in-out, transform 240ms ease-in-out;
}

.dropdown-animation-enter-from,
.dropdown-animation-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>